module.exports = __webpack_public_path__ + "img/logo-and-name.d672f82.png";